import { useMutation } from 'react-query';

import {
  CreateAiCohortNotificationsUserParams,
  createAiCohortNotificationsUser,
} from '@utils/backend-api/aiCohortNotificationsUsers';

export default function useAiCohortNotificationsUserCreate() {
  const { mutate, mutateAsync, data, isLoading, isError } = useMutation(
    (values: CreateAiCohortNotificationsUserParams) => createAiCohortNotificationsUser(values)
  );
  return { mutate, mutateAsync, data, isLoading, isError };
}
